import React from "react";

export function BrandLogo({ size = 44, showText = true }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src="/bwz-logo.png"
        alt="BrandOnWheelz"
        style={{ height: size, width: "auto" }}
        className="object-contain select-none"
        draggable="false"
      />
      {showText && (
        <div className="leading-tight hidden sm:block border-l border-zinc-300 pl-3">
          <div className="text-[10px] uppercase tracking-[0.24em] text-zinc-500 font-medium">
            Sales Pricelist Console
          </div>
          <div className="text-[11px] text-zinc-400 font-mono-num">v1.0 · Internal</div>
        </div>
      )}
    </div>
  );
}
